import { useContent } from "@/content";
import { useSeo } from "@/lib/hooks";
import { Hero3 } from "@/sections/v3/Hero3";
import { Essence3, Why3, Who3 } from "@/sections/v3/Intro3";
import { Categories3 } from "@/sections/v3/Categories3";
import { Journey3, Dates3 } from "@/sections/v3/Journey3";
import { Jury3 } from "@/sections/v3/Jury3";
import { Criteria3, Ecosystem3 } from "@/sections/v3/Criteria3";
import { Selection3 } from "@/sections/v3/Showcase3";
import { FinalCall3 } from "@/sections/v3/FinalCall3";
export { CategoriesPage, FinalistsPage, WinnersPage, ApplyPage, ContactPage, NotFound } from "@/pages2";

// VERSION 3B « Programme de gala » : architecture à panneau latéral fixe.
export const Home = () => {
  useSeo(useContent().seo.home);
  return (
    <>
      <Hero3 />
      <Essence3 />
      <Why3 />
      <Who3 />
      <Categories3 />
      <Journey3 />
      <Dates3 />
      <Jury3 />
      <Criteria3 />
      <Selection3 />
      <Ecosystem3 />
      <FinalCall3 />
    </>
  );
};
